import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Helmet } from "react-helmet";
import theme from "./config/theme";
import Login from "./pages/login";
import Register from "./pages/register";
import { LayoutA, LayoutB, SalesReport, DataJaringan, PreorderReport } from "./pages/private";
import NotFound from "./pages/404";
import PrivateRoute from "./components/routing/PrivateRoute";
import FirebaseProvider from "./components/firebase/FirebaseProvider";
import PaymentMidtrans from "./pages/private/Payment";
import Finish from "./pages/private/Payment/Finish";
import OrderFinish from "./pages/private/Payment/OrderFinish";
import { MidtransClientKey, MidtransUrl } from "./config/Midtrans";
import { SnackbarProvider } from "notistack";
import StokProduk from "./pages/stokProduk";
import DesignContest from "./pages/designContest";
import ReactPixel from "react-facebook-pixel";

if("https://app.tokorame.co.id/" == window.location.href){
  ReactPixel.init("524136976398919");
  ReactPixel.pageView(); // For tracking page view
}

function App() {
  return (
    <>
      <Helmet>
        <script
          src={MidtransUrl}
          data-client-key={MidtransClientKey}
          type="text/javascript"
        />
        <meta name="facebook-domain-verification" content="arnyiessbd60cug7ig5zcxy1zavn23" />
      </Helmet>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: "#f0f0f0" }}>
              <FirebaseProvider>
                <Router>
                  {/* <ScrollToTop /> */}
                  <Switch>
                    <PrivateRoute exact path="/" component={LayoutA} />
                    <PrivateRoute exact path="/kategori" component={LayoutB} />
                    <PrivateRoute exact path="/tokosaya" component={LayoutA} />
                    <PrivateRoute path="/tokosaya/pilih" component={LayoutB} />
                    <PrivateRoute path="/collections/:id" component={LayoutB} />
                    <PrivateRoute path="/tokosaya/promo" component={LayoutB} />
                    <PrivateRoute exact path="/transaksi" component={LayoutA} />
                    <PrivateRoute path="/browse" component={LayoutB} />
                    <PrivateRoute path="/kategori/:id" component={LayoutB} />
                    <PrivateRoute
                      path="/produk/:nama/:id"
                      component={LayoutB}
                    />
                    <PrivateRoute exact path="/akun" component={LayoutA} />
                    <PrivateRoute path="/notification" component={LayoutA} />
                    <PrivateRoute exact path="/alamat" component={LayoutB} />
                    <PrivateRoute path="/akun/ubahseller" component={LayoutB} />
                    <PrivateRoute path="/akun/ubahtoko" component={LayoutB} />
                    <PrivateRoute
                      path="/akun/rewardpoint"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/reward-produk/:nama/:id"
                      component={LayoutB}
                    />
                    <PrivateRoute path="/akun/pengaturan" component={LayoutB} />
                    <PrivateRoute path="/akun/verifikasi" component={LayoutB} />
                    <PrivateRoute path="/akun/rekening" component={LayoutB} />
                    <PrivateRoute path="/akun/ubahsandi" component={LayoutB} />
                    <PrivateRoute path="/akun/bantuan" component={LayoutB} />
                    <PrivateRoute path="/akun/rewardlist" component={LayoutB} />

                    <PrivateRoute
                      path="/transaksi/komisisaya"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/transaksi/pencairansaya"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/transaksi/transaksilist/:mode/:title"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/transaksi/jaringansaya"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/transaksi/rekomendasisaya"
                      component={LayoutB}
                    />
                    <PrivateRoute path="/cart" component={LayoutB} />
                    <PrivateRoute path="/checkout" component={LayoutB} />
                    <PrivateRoute
                      exact
                      path="/tokoramecoin"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/tokoramecoin/riwayat"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/tokoramecoin/info"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/tokoramecoin/daily-checkin"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/tokoramecoin/voucher-history"
                      component={LayoutB}
                    />
                    <PrivateRoute
                      path="/donasi/:id/:idReference"
                      component={LayoutB}
                    />
                    <PrivateRoute path="/salesreport" component={SalesReport} />
                    <PrivateRoute path="/laporan-preorder" component={PreorderReport} />
                    <PrivateRoute
                      path="/datajaringan"
                      component={DataJaringan}
                    />
                    <PrivateRoute path="/moota/:token" component={LayoutB} />
                    <Route path="/login" component={Login} />
                    <Route path="/stock-available" component={StokProduk} />
                    <Route path="/register" component={Register} />
                    <Route path="/payment/:token" component={PaymentMidtrans} />
                    <Route path="/finish/:id" component={Finish} />
                    <Route path="/order/finish/:id" component={OrderFinish} />
                    <Route
                      path="/fashion-design-competition"
                      component={DesignContest}
                    />
                    <Route component={NotFound} />
                  </Switch>
                </Router>
              </FirebaseProvider>
            </div>
          </ThemeProvider>
        </CssBaseline>
      </SnackbarProvider>
    </>
  );
}
export default App;
